import styled from 'styled-components';
import { Stack } from '@karma/components';

export const Content = styled(Stack).attrs({
  direction: 'column',
})`
  width: 290px;
  margin: 0 auto;
`;
